class CartNotification extends HTMLElement {
	constructor() {
		super();

		this.notification = document.getElementById( 'cart-notification' );
		this.header = document.querySelector( 'sticky-header' );
		this.onBodyClick = this.handleBodyClick.bind( this );

		this.notification.addEventListener( 'keyup', ( evt ) => evt.code === 'Escape' && this.close() );
		this.querySelectorAll( 'button[type="button"]' ).forEach( ( closeButton ) =>
			closeButton.addEventListener( 'click', this.close.bind( this ) )
		);

		this.target = document.querySelector( ".header__icon--cart" );
		this.cartItem = this.querySelector( ".cart_items" );
		this.cartNote = this.querySelector( ".cart_note" );
		this.cartProducts = this.querySelector( ".cart_items_products" );

		this.target.addEventListener( "mouseover", this.mOver.bind( this ), false );

		this.addEventListener('mouseleave', this.close.bind(this));

		this.hideCartNote();
		this.loadCartContents();
	}

	open() {
		this.notification.classList.add( 'animate', 'active' );

		this.notification.addEventListener( 'transitionend', () => {
			this.notification.focus();
			trapFocus( this.notification );
		}, {once: true} );

		document.body.addEventListener( 'click', this.onBodyClick );
	}

	close() {
		this.notification.classList.remove( 'active' );

		document.body.removeEventListener( 'click', this.onBodyClick );

		removeTrapFocus( this.activeElement );
	}

	mOver() {
		this.open();
	}

	loadCartContents() {
		return jQuery.getJSON( '/cart.js', ( cart ) => {
			console.log('loadCartContents', cart );
			let qty = cart.item_count;
			this.cartProducts.innerHTML = '';
			if ( qty > 0) {
				for ( let i = 0; i < cart.items.length; i ++ ) {
					let image = cart.items[i].featured_image.url.split( '.jpg' );
					image = image[0] + '_140x.jpg';
					let name = cart.items[i].options_with_values[0].name;
					let value = cart.items[i].options_with_values[0].value;
					if ( name.indexOf( 'Title' ) >= 0 ) {
						name = '';
					}
					if ( value.indexOf( 'Title' ) >= 0 ) {
						value = '';
					}
					let sellingPlan = ''
					if ( cart.items[i].selling_plan_allocation ) {
						sellingPlan = '<p class="product-option">' + cart.items[i].selling_plan_allocation.selling_plan.name + '</p>'

					}

					this.cartProducts.innerHTML += '<div id="cart-notification-product-' + cart.items[i].id + '" class="cart-item ajaxed_item">' +
					                               '<div class="cart-notification-product__image global-media-settings">' +
					                               '<img src="' + image + '" alt="' + cart.items[i].featured_image.alt + '" height="86" width="70" loading="lazy">' +
					                               '</div>' +
					                               '<div>' +
					                               '<h3 class="cart-notification-product__name h6">' + cart.items[i].product_title + '</h3>' +
					                               '<dl> <div class="product-option"><dt>' + name + ' </dt><dd>' + value + '</dd></div></dl> ' + sellingPlan +
					                               '<div class="cart-notification-product__price-qty">' +
					                               '<div class="cart-notification-product__qty h6">Quantity: ' + cart.items[i].quantity + '</div>' +
					                               '<div class="cart-notification-product__price h6">Price: ' + Shopify.formatCurrency(cart.items[i].price / 100) +
																				 '</div>' +
					                               '</div>' +
					                               '</div>' +
					                               '</div> ';
				}
				this.cartProducts.classList.remove('hidden');
				this.cartItem.classList.add('hidden');
			} else {
				console.log( 'empty cart' );
				this.cartItem.innerHTML = 'Your cart is empty.';
				this.cartItem.classList.remove('hidden');
			}
		} );
	}

	/*
	Used from product-form when product gets added to cart.
	*/
	productJustAddedToCart( parsedState ) {
		this.productId = parsedState.id;
		this.getSectionsToRender().forEach( (
			section => {
				document.getElementById( section.id ).innerHTML =
					this.getSectionInnerHTML( parsedState.sections[section.id], section.selector );
			}
		) );
		this.loadCartContents().then(()=>{
			this.showCartNote()
			setTimeout(()=>{
				this.hideCartNote();
			}, 2000);
		});

		if ( this.header ) {
			this.header.reveal();
		}
		this.open();
	}

	productJustAddedToCartByQuickAdd(){
		this.loadCartContents().then(()=>{
			this.showCartNote()
			setTimeout(()=>{
				this.hideCartNote();
			}, 2000);
		});

		if ( this.header ) {
			this.header.reveal();
		}
		this.open();
	}

	showCartNote(){
		this.cartNote.classList.remove('hidden');
	}
	hideCartNote(){
		this.cartNote.classList.add('hidden');
	}

	getSectionsToRender() {
		return [
			// {
			// 	id: 'cart-notification-product',
			// 	selector: `#cart-notification-product-${this.productId}`,
			// },
			{
				id: 'cart-notification-button'
			},
			{
				id: 'cart-icon-bubble'
			}
		];
	}

	getSectionInnerHTML( html, selector = '.shopify-section' ) {
		return new DOMParser()
			.parseFromString( html, 'text/html' )
			.querySelector( selector ).innerHTML;
	}

	handleBodyClick( evt ) {
		const target = evt.target;
		if ( target !== this.notification && !target.closest( 'cart-notification' ) ) {
			const disclosure = target.closest( 'details-disclosure' );
			this.activeElement = disclosure ? disclosure.querySelector( 'summary' ) : null;
			this.close();
		}
	}

	setActiveElement( element ) {
		this.activeElement = element;
	}
}

customElements.define( 'cart-notification', CartNotification );
